import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import CardETFsEvents from "../../components/ui/card/CardETFsEvents";
import Carousel from "../../components/ui/carouselSimple/Carousel";

const dominio = process.env.REACT_APP_DOMINIO;

function Eventos(props) {

  let [eventos, setEventos] = useState([]);
  let [eventosCards, setEventosCards] = useState([]);

  useEffect(() => {
    let urlEventos = `${dominio}/cms/o/documents/etf-eventos/lang/${props.lang}`;

    axios.get(urlEventos)
      .then(response => {
        setEventos(response.data);
      })
      .catch(err => console.error("Error al obtener la lista de eventos. " + err.message));
  }, []);

  useEffect(() => {
    let tmpEventosCards = [];
    eventos.map((evento, index) => {
      tmpEventosCards.push(
        <CardETFsEvents
          key={index}
          image={`${dominio}${evento.imagen}`}
          title={evento.titulo}
          description={evento.detalle}
          buttonText={"Registrate"}
          src={evento.registro} />
      );
    })
    setEventosCards(tmpEventosCards);
  }, [eventos]);

  return (
    <Carousel slides={eventosCards} secondsToChange={10} height={'500px'} />
  );
}

Eventos.propTypes = {
    lang: PropTypes.string
}

export default memo(Eventos);
